import { useContext, useState } from "react"
import { AppContext } from "../App"
import { MdCall, MdKeyboardArrowDown, MdMenu } from "react-icons/md";
import logo from '../assets/logo.png';
import logo_icon from '../assets/logo_icon.png';

export default function TopBar(props) {

  const appContext = useContext(AppContext);
  const [openGroup, setOpenGroup] = useState(null);

  const groupedMenu = [
    {
      key: "about_us",
      label: "About Us",
      subItems: [
        { label: "Overview", targetId: "about-overview" },
        { label: "Our Values", subItem: "values" },
        { label: "Why Work with Us", subItem: "work-with-us" },
      ],
    },
    {
      key: "products",
      label: "Products",
      subItems: [
        { label: "Solutions Overview", subItem: null },
        { label: "Light Gauge Steel", subItem: "light-gauge-steel" },
        { label: "Waterproofing Solutions", subItem: "waterproofing-solutions" },
        { label: "Terrazzo Flooring", subItem: "terrazzo-flooring" },
        { label: "Additional Services", subItem: "additional-services" }
      ],
    },
    {
      key: "projects",
      label: "Our Experience",
      subItems: [
        { label: "Project Gallery", subItem: "gallery" },
      ],
    },
  ];

  function goTo(item) {
    appContext.navTo({
      item,
    })
    setOpenGroup(null);
  }

  function goToSection(item, targetId) {
    appContext.navToSection(item, targetId);
    setOpenGroup(null);
  }

  function goToSubItem(item, subItem) {
    appContext.navTo({
      item,
      subItem: subItem || undefined,
    });
    setOpenGroup(null);
  }

  return (
    <div
      className="TopBar topbar-refined"
    >
      <div className="body">
        <div
          className="container d-flex justify-content-between"
          style={{
            height: "100%",
          }}
        >
          <div 
            className="align-self-center d-flex"
            style={{
              height: "100%",
              flexShrink: 1,

            }}
          >
            <MdMenu
              className="align-self-center mMobileOnly"
              size={32}
              style={{
                flexShrink: 0,
                cursor: "pointer",
                marginRight: "0px"
              }}
              onClick={appContext.openSideBar}
            />

            <img
              src={logo}
              alt="Group V logo"
              style={{
                height: "50px",
                width: "auto",
                margin: "0",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mDesktopOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />

            <img
              src={logo_icon}
              alt="Group V icon"
              style={{
                height: "50px",
                width: "auto",
                margin: "0",
                marginLeft: "10px",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mMobileOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />
          </div>

          <div
            className="DesktopMenu align-self-center mNoMargin mNoPadding"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
              onClick={() => goTo("home")}
              data-active={appContext.navItem === 'home' || !appContext.navItem}
            >
              Home
            </div>

            {groupedMenu.map((group) => (
              <div
                key={group.key}
                className="mMenuItem topbar-menu-group"
                data-active={appContext.navItem === group.key}
                onMouseEnter={() => setOpenGroup(group.key)}
                onMouseLeave={() => setOpenGroup(null)}
              >
                <button className="topbar-group-label" onClick={() => goTo(group.key)}>
                  {group.label}
                </button>
                <button
                  className="topbar-group-arrow"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenGroup(openGroup === group.key ? null : group.key);
                  }}
                >
                  <MdKeyboardArrowDown
                    size={18}
                    className="topbar-group-arrow-icon"
                    data-open={openGroup === group.key}
                  />
                </button>

                <div className={`topbar-submenu ${openGroup === group.key ? "is-open" : ""}`}>
                  {group.subItems.map((sub) => (
                    <button
                      key={sub.subItem || sub.targetId || sub.label}
                      className="topbar-submenu-item"
                      onClick={() =>
                        sub.targetId
                          ? goToSection(group.key, sub.targetId)
                          : goToSubItem(group.key, sub.subItem)
                      }
                    >
                      {sub.label}
                    </button>
                  ))}
                </div>
              </div>
            ))}

            <div
              className="mMenuItem"
              onClick={() => goTo("contact_us")}
              
            >
              <button
                className="btn font-bold btn-primary btn-rounded"
                style={{
                  fontSize: "14px"
                }}
              >
                <MdCall className="text-light" size={32}/>
              </button>
            </div>

          </div>

          <div
            className="align-self-center mNoMargin mNoPadding mMobileOnly"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
            >
              <button
                className="btn btn-primary font-bold btn-rounded"
                style={{
                  fontSize: "14px"
                }}
                onClick={() => goTo("contact_us")}
              >
                Contact Us
              </button>
            </div>

          </div>

        </div>
      </div>

      <style>{`
        .topbar-refined > .body {
          background: linear-gradient(170deg, rgba(255, 255, 255, 0.97), rgba(248, 252, 255, 0.97));
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(164, 196, 219, 0.28);
          box-shadow: 0 6px 16px rgba(24, 50, 72, 0.07);
          font-size:20px;
        }

        .topbar-refined .mMenuItem {
          border-radius: 9px;
          transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
          text-transform:uppercase;
        }

        .topbar-refined .DesktopMenu > .mMenuItem:hover {
          background: rgba(117, 171, 209, 0.1);
          color: #1f5981;
          transform: translateY(0);
        }

        .topbar-refined .DesktopMenu > .mMenuItem[data-active='true'] {
          background: rgba(96, 156, 197, 0.14);
          color: #1d547a;
          box-shadow: inset 0 0 0 1px rgba(122, 178, 216, 0.24);
        }

        .topbar-refined .DesktopMenu .mMenuItem:last-child {
          background: transparent;
          box-shadow: none;
        }

        .topbar-refined img {
          transition: transform 0.2s ease, filter 0.2s ease;
        }

        .topbar-refined img:hover {
          transform: translateY(0);
          filter: saturate(1.05);
        }

        .topbar-menu-group {
          position: relative;
          gap: 4px;
          margin-right: 2px;
        }

        .topbar-group-label,
        .topbar-group-arrow {
          border: none;
          background: transparent;
          color: inherit;
          font: inherit;
          padding: 0;
          line-height: 1;
          text-transform:uppercase;
        }

        .topbar-group-label {
          cursor: pointer;
        }

        .topbar-group-arrow {
          width: 18px;
          height: 18px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .topbar-group-arrow-icon {
          transition: transform 0.2s ease;
        }

        .topbar-group-arrow-icon[data-open='true'] {
          transform: rotate(180deg);
        }

        .topbar-submenu {
          position: absolute;
          top: calc(100% + 12px);
          left: 0;
          min-width: 230px;
          border: 1px solid rgba(152, 186, 212, 0.34);
          border-radius: 10px;
          background: #ffffff;
          box-shadow: 0 10px 22px rgba(16, 38, 55, 0.13);
          padding: 7px;
          display: grid;
          gap: 4px;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-6px);
          transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
          z-index: calc(var(--lowIndex) + 2);
        }

        .topbar-submenu.is-open {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .topbar-submenu-item {
          width: 100%;
          text-align: left;
          border: 1px solid transparent;
          border-radius: 7px;
          padding: 7px 10px;
          background: transparent;
          color: #2f3e4d;
          font-size: 13px;
          font-family: "FontSemiBold";
          transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
        }

        .topbar-submenu-item:hover {
          background: #eff6fc;
          border-color: #d7e6f3;
          transform: translateX(1px);
        }

        @media (max-width: 767px) {
          .topbar-refined > .body {
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      `}</style>
    </div>
  )
}
